//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapMutations } from "vuex";
import { openDB } from "idb";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    showSnackbar: false,
    snackbarMessage: "",
    snackbarColor: "error",

    siteOrgCode: null,
    sites: [],
  }),
  computed: {},
  methods: {
    ...mapMutations(["setCrfTitle"]),
    ...mapActions(["fetchSites", "fetchDefaultSiteOrgCode"]),
    async saveSettingChanges() {
      const db = await openDB("AIRWAYS3idb");
      await db
        .transaction("tbSettings", "readwrite")
        .objectStore("tbSettings")
        .put(this.siteOrgCode, "defaultSite");

      this.snackbarColor = "success";
      this.snackbarMessage = "Saved successfully.";
      this.showSnackbar = true;
    },
  },
  async mounted() {
    this.setCrfTitle("Settings");
    this.sites = await this.fetchSites();
    this.siteOrgCode = await this.fetchDefaultSiteOrgCode();
  },
};
